import React, { useEffect, useMemo, useState } from "react";
import Lightbox from "yet-another-react-lightbox";
import "yet-another-react-lightbox/styles.css";
import "yet-another-react-lightbox/plugins/thumbnails.css";
import Thumbnails from "yet-another-react-lightbox/plugins/thumbnails";
import Zoom from "yet-another-react-lightbox/plugins/zoom";
import Video from "yet-another-react-lightbox/plugins/video";

import { RWebShare } from "react-web-share";
import "../Gallery and Amenities/gallery-collage.css";
import HeroCollage from "../Gallery and Amenities/HeroCollage";

const isVideoSrc = (src, type) => {
  if (String(type || "").toUpperCase() === "VIDEO") return true;
  return /\.(mp4|webm|mov|m4v|avi)(\?|$)/i.test(String(src || ""));
};

const guessVideoMime = (src) => {
  const lower = String(src).toLowerCase();
  if (lower.includes(".webm")) return "video/webm";
  if (lower.includes(".mov")) return "video/quicktime";
  return "video/mp4";
};

const Title = ({ villaData }) => {
  const [open, setOpen] = useState(false);
  const [lightboxOpen, setLightboxOpen] = useState(false);
  const [lightboxIndex, setLightboxIndex] = useState(0);

  const mediaItems = useMemo(() => {
    const media = Array.isArray(villaData?.media) ? [...villaData.media] : [];
    const order = Array.isArray(villaData?.media_order)
      ? villaData.media_order
      : [];
    if (order.length > 0) {
      media.sort((a, b) => {
        const idA = a.mediafiles_id ?? a?.media?.id;
        const idB = b.mediafiles_id ?? b?.media?.id;
        const indexA = order.indexOf(idA);
        const indexB = order.indexOf(idB);
        const safeA = indexA === -1 ? Number.MAX_SAFE_INTEGER : indexA;
        const safeB = indexB === -1 ? Number.MAX_SAFE_INTEGER : indexB;
        return safeA - safeB;
      });
    }
    return media
      .map((item) => {
        const src = item?.media?.file;
        if (!src) return null;
        const type = item?.media?.type;
        return { src, type, isVideo: isVideoSrc(src, type) };
      })
      .filter(Boolean);
  }, [villaData?.media, villaData?.media_order]);

  const images = useMemo(
    () =>
      mediaItems.map((item) => {
        if (item.isVideo) {
          return {
            type: "video",
            width: 1920,
            height: 1080,
            sources: [{ src: item.src, type: guessVideoMime(item.src) }],
          };
        }
        return { src: item.src };
      }),
    [mediaItems]
  );

  useEffect(() => {
    if (!open) return undefined;
    const prev = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = prev;
    };
  }, [open]);

  return (
    <div className=" font-jt relative">
      <div className="hidden  w-[97%] lg:w-[95vw] items-center relative lg:flex flex-row rounded-full justify-between bg-black text-white mt-8 mx-auto">
        <div className="ml-6 lg:ml-10 flex flex-col">
          <div className=" flex flex-row items-center">
            <div className=" ml-1 lg:mt-0 lg:ml-0 text-[20px] lg:text-[35px] font-semibold">
              {villaData.listing_name?villaData.listing_name:villaData.property_name}
            </div>
            <div className="hidden ml-4 mt-1 lg:flex flex-row ">
              <svg
                width="23"
                height="20"
                viewBox="0 0 23 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M8.12914 6.4475C8.12914 6.4475 4.09136 6.885 1.3978 7.1775C1.15502 7.20625 0.940358 7.365 0.859858 7.60625C0.779358 7.8475 0.859858 8.09875 1.03875 8.2575C3.03975 10.0437 6.04636 12.7187 6.04636 12.7187C6.0438 12.7187 5.22091 16.61 4.67403 19.2062C4.62803 19.4412 4.71491 19.69 4.92447 19.8387C5.13275 19.9875 5.40108 19.99 5.61191 19.8737C7.96814 18.5637 11.4974 16.5937 11.4974 16.5937C11.4974 16.5937 15.0279 18.5637 17.3802 19.875C17.5949 19.99 17.8632 19.9875 18.0715 19.8387C18.2811 19.69 18.368 19.4412 18.3207 19.2075C17.7738 16.61 16.9522 12.7187 16.9522 12.7187C16.9522 12.7187 19.9588 10.0437 21.9598 8.26125C22.1387 8.0975 22.2179 7.84625 22.1387 7.60625C22.0595 7.36625 21.8448 7.2075 21.602 7.18C18.9085 6.885 14.8694 6.4475 14.8694 6.4475C14.8694 6.4475 13.1955 2.825 12.08 0.409996C11.9752 0.193746 11.7555 0.0424957 11.4974 0.0424957C11.2392 0.0424957 11.0182 0.194996 10.9185 0.409996C9.80175 2.825 8.12914 6.4475 8.12914 6.4475Z"
                  fill="#E8BD25"
                />
              </svg>
              <svg
                width="23"
                height="20"
                viewBox="0 0 23 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M8.12914 6.4475C8.12914 6.4475 4.09136 6.885 1.3978 7.1775C1.15502 7.20625 0.940358 7.365 0.859858 7.60625C0.779358 7.8475 0.859858 8.09875 1.03875 8.2575C3.03975 10.0437 6.04636 12.7187 6.04636 12.7187C6.0438 12.7187 5.22091 16.61 4.67403 19.2062C4.62803 19.4412 4.71491 19.69 4.92447 19.8387C5.13275 19.9875 5.40108 19.99 5.61191 19.8737C7.96814 18.5637 11.4974 16.5937 11.4974 16.5937C11.4974 16.5937 15.0279 18.5637 17.3802 19.875C17.5949 19.99 17.8632 19.9875 18.0715 19.8387C18.2811 19.69 18.368 19.4412 18.3207 19.2075C17.7738 16.61 16.9522 12.7187 16.9522 12.7187C16.9522 12.7187 19.9588 10.0437 21.9598 8.26125C22.1387 8.0975 22.2179 7.84625 22.1387 7.60625C22.0595 7.36625 21.8448 7.2075 21.602 7.18C18.9085 6.885 14.8694 6.4475 14.8694 6.4475C14.8694 6.4475 13.1955 2.825 12.08 0.409996C11.9752 0.193746 11.7555 0.0424957 11.4974 0.0424957C11.2392 0.0424957 11.0182 0.194996 10.9185 0.409996C9.80175 2.825 8.12914 6.4475 8.12914 6.4475Z"
                  fill="#E8BD25"
                />
              </svg>
              <svg
                width="23"
                height="20"
                viewBox="0 0 23 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M8.12914 6.4475C8.12914 6.4475 4.09136 6.885 1.3978 7.1775C1.15502 7.20625 0.940358 7.365 0.859858 7.60625C0.779358 7.8475 0.859858 8.09875 1.03875 8.2575C3.03975 10.0437 6.04636 12.7187 6.04636 12.7187C6.0438 12.7187 5.22091 16.61 4.67403 19.2062C4.62803 19.4412 4.71491 19.69 4.92447 19.8387C5.13275 19.9875 5.40108 19.99 5.61191 19.8737C7.96814 18.5637 11.4974 16.5937 11.4974 16.5937C11.4974 16.5937 15.0279 18.5637 17.3802 19.875C17.5949 19.99 17.8632 19.9875 18.0715 19.8387C18.2811 19.69 18.368 19.4412 18.3207 19.2075C17.7738 16.61 16.9522 12.7187 16.9522 12.7187C16.9522 12.7187 19.9588 10.0437 21.9598 8.26125C22.1387 8.0975 22.2179 7.84625 22.1387 7.60625C22.0595 7.36625 21.8448 7.2075 21.602 7.18C18.9085 6.885 14.8694 6.4475 14.8694 6.4475C14.8694 6.4475 13.1955 2.825 12.08 0.409996C11.9752 0.193746 11.7555 0.0424957 11.4974 0.0424957C11.2392 0.0424957 11.0182 0.194996 10.9185 0.409996C9.80175 2.825 8.12914 6.4475 8.12914 6.4475Z"
                  fill="#E8BD25"
                />
              </svg>
              <svg
                width="23"
                height="20"
                viewBox="0 0 23 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M8.12914 6.4475C8.12914 6.4475 4.09136 6.885 1.3978 7.1775C1.15502 7.20625 0.940358 7.365 0.859858 7.60625C0.779358 7.8475 0.859858 8.09875 1.03875 8.2575C3.03975 10.0437 6.04636 12.7187 6.04636 12.7187C6.0438 12.7187 5.22091 16.61 4.67403 19.2062C4.62803 19.4412 4.71491 19.69 4.92447 19.8387C5.13275 19.9875 5.40108 19.99 5.61191 19.8737C7.96814 18.5637 11.4974 16.5937 11.4974 16.5937C11.4974 16.5937 15.0279 18.5637 17.3802 19.875C17.5949 19.99 17.8632 19.9875 18.0715 19.8387C18.2811 19.69 18.368 19.4412 18.3207 19.2075C17.7738 16.61 16.9522 12.7187 16.9522 12.7187C16.9522 12.7187 19.9588 10.0437 21.9598 8.26125C22.1387 8.0975 22.2179 7.84625 22.1387 7.60625C22.0595 7.36625 21.8448 7.2075 21.602 7.18C18.9085 6.885 14.8694 6.4475 14.8694 6.4475C14.8694 6.4475 13.1955 2.825 12.08 0.409996C11.9752 0.193746 11.7555 0.0424957 11.4974 0.0424957C11.2392 0.0424957 11.0182 0.194996 10.9185 0.409996C9.80175 2.825 8.12914 6.4475 8.12914 6.4475Z"
                  fill="#E8BD25"
                />
              </svg>
              <svg
                width="23"
                height="20"
                viewBox="0 0 23 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M8.12914 6.4475C8.12914 6.4475 4.09136 6.885 1.3978 7.1775C1.15502 7.20625 0.940358 7.365 0.859858 7.60625C0.779358 7.8475 0.859858 8.09875 1.03875 8.2575C3.03975 10.0437 6.04636 12.7187 6.04636 12.7187C6.0438 12.7187 5.22091 16.61 4.67403 19.2062C4.62803 19.4412 4.71491 19.69 4.92447 19.8387C5.13275 19.9875 5.40108 19.99 5.61191 19.8737C7.96814 18.5637 11.4974 16.5937 11.4974 16.5937C11.4974 16.5937 15.0279 18.5637 17.3802 19.875C17.5949 19.99 17.8632 19.9875 18.0715 19.8387C18.2811 19.69 18.368 19.4412 18.3207 19.2075C17.7738 16.61 16.9522 12.7187 16.9522 12.7187C16.9522 12.7187 19.9588 10.0437 21.9598 8.26125C22.1387 8.0975 22.2179 7.84625 22.1387 7.60625C22.0595 7.36625 21.8448 7.2075 21.602 7.18C18.9085 6.885 14.8694 6.4475 14.8694 6.4475C14.8694 6.4475 13.1955 2.825 12.08 0.409996C11.9752 0.193746 11.7555 0.0424957 11.4974 0.0424957C11.2392 0.0424957 11.0182 0.194996 10.9185 0.409996C9.80175 2.825 8.12914 6.4475 8.12914 6.4475Z"
                  fill="#BCBCBC"
                />
              </svg>
              (20)
            </div>
            <div className="hidden lg:block ml-4 mt-1">
            <RWebShare
              data={{
                url: `http://www.a2zvillaz.com/villa/${villaData.property_ptr_id}/${villaData?.listing_name?.replace(/\s+/g, "-")}`,
                title: "A2Z Villaz",
              }}
              onClick={() => console.log("shared successfully!")}
            >
              <button className=" cursor-pointer">
              <svg
                width="20"
                height="20"
                viewBox="0 0 30 32"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M24.0548 21.0469C22.7 21.0465 21.399 21.577 20.4307 22.5246L10.9923 17.2179C11.1863 16.4176 11.1863 15.5825 10.9923 14.7821L20.4277 9.47544C21.3092 10.3329 22.4671 10.8486 23.6941 10.9302C24.9211 11.0118 26.1371 10.6541 27.1244 9.92097C28.1117 9.18788 28.8058 8.12731 29.0825 6.92914C29.3592 5.73096 29.2004 4.47342 28.6346 3.38164C28.0687 2.28986 27.1327 1.43513 25.9942 0.970466C24.8557 0.505802 23.5889 0.461546 22.4207 0.845621C21.2525 1.22969 20.2592 2.01702 19.6185 3.06665C18.9778 4.11628 18.7317 5.35967 18.9241 6.57423L9.26599 12.007C8.50737 11.375 7.58435 10.9722 6.60505 10.8459C5.62576 10.7196 4.63074 10.875 3.73657 11.2938C2.84241 11.7127 2.08612 12.3777 1.55631 13.2109C1.0265 14.0442 0.745117 15.0111 0.745117 15.9985C0.745117 16.9859 1.0265 17.9529 1.55631 18.7861C2.08612 19.6194 2.84241 20.2844 3.73657 20.7032C4.63074 21.1221 5.62576 21.2775 6.60505 21.1512C7.58435 21.0248 8.50737 20.6221 9.26599 19.99L18.9241 25.4258C18.7571 26.4751 18.9159 27.5503 19.3789 28.5066C19.842 29.4628 20.5871 30.2541 21.5139 30.7737C22.4406 31.2934 23.5044 31.5164 24.5618 31.4127C25.6192 31.3091 26.6194 30.8837 27.4275 30.194C28.2357 29.5042 28.8129 28.5833 29.0815 27.5553C29.35 26.5273 29.2969 25.4417 28.9294 24.4449C28.5618 23.448 27.8974 22.5878 27.0258 21.9802C26.1542 21.3726 25.1173 21.0469 24.0548 21.0469Z"
                  fill="white"
                />
              </svg>
              </button>
            </RWebShare>
            </div>
          </div>
          <div className="flex flex-row  mt-1 text-sm lg:text-base">
            <div>
              <svg
                width="25"
                height="22"
                viewBox="0 0 20 32"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                className="lg:block hidden"
              >
                <path
                  d="M10.0003 0C4.50859 0 0.0585938 4.475 0.0585938 10C0.0585938 19.55 10.0003 32 10.0003 32C10.0003 32 19.9419 19.55 19.9419 10C19.9419 4.475 15.4919 0 10.0003 0ZM10.0003 14.85C7.40026 14.85 5.30026 12.7333 5.30026 10.125C5.30026 7.51667 7.40859 5.39167 10.0003 5.39167C12.6003 5.39167 14.7003 7.50833 14.7003 10.125C14.7003 12.7333 12.6003 14.85 10.0003 14.85Z"
                  fill="white"
                />
              </svg>
              <svg
                width="13"
                height="12"
                viewBox="0 0 20 32"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                className="lg:mt-0 mt-1 block lg:hidden"
              >
                <path
                  d="M10.0003 0C4.50859 0 0.0585938 4.475 0.0585938 10C0.0585938 19.55 10.0003 32 10.0003 32C10.0003 32 19.9419 19.55 19.9419 10C19.9419 4.475 15.4919 0 10.0003 0ZM10.0003 14.85C7.40026 14.85 5.30026 12.7333 5.30026 10.125C5.30026 7.51667 7.40859 5.39167 10.0003 5.39167C12.6003 5.39167 14.7003 7.50833 14.7003 10.125C14.7003 12.7333 12.6003 14.85 10.0003 14.85Z"
                  fill="white"
                />
              </svg>
            </div>
            <div>
              {villaData.area
                ? villaData.area
                : villaData.building
                  ? villaData.building
                  : villaData.name}
            </div>
          </div>
        </div>

        <div className="hidden lg:relative">
          <svg
            width="400"
            height="110"
            viewBox="0 0 504 151"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g opacity="0.3">
              <path
                d="M156.395 147.199V143.075C156.395 136.242 161.932 130.704 168.765 130.704C175.598 130.704 181.136 136.242 181.136 143.075V147.199H156.395Z"
                stroke="white"
                stroke-width="2"
                stroke-miterlimit="10"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M197.63 147.199V143.075C197.63 136.242 203.168 130.704 210.001 130.704C216.833 130.704 222.371 136.242 222.371 143.075V147.199H197.63Z"
                stroke="white"
                stroke-width="2"
                stroke-miterlimit="10"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M238.865 147.199V143.075C238.865 136.242 244.403 130.704 251.236 130.704C258.069 130.704 263.607 136.242 263.607 143.075V147.199H238.865Z"
                stroke="white"
                stroke-width="2"
                stroke-miterlimit="10"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M129.962 118.375L134.539 163.693H277.503L285.049 114.21"
                stroke="white"
                stroke-width="2"
                stroke-miterlimit="10"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M108.836 114.21H298.792L285.506 89.4688H134.357L108.836 114.21Z"
                stroke="white"
                stroke-width="2"
                stroke-miterlimit="10"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M144.023 89.4688L135.776 39.9861"
                stroke="white"
                stroke-width="2"
                stroke-miterlimit="10"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M181.136 89.4688L185.259 39.9861"
                stroke="white"
                stroke-width="2"
                stroke-miterlimit="10"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M193.507 39.9861H123.406L156.395 -13.6202L193.507 39.9861Z"
                stroke="white"
                stroke-width="2"
                stroke-miterlimit="10"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M168.765 56.4803H152.271V72.9746H168.765V56.4803Z"
                stroke="white"
                stroke-width="2"
                stroke-miterlimit="10"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M259.483 -5.37308H242.989V11.1212H259.483V-5.37308Z"
                stroke="white"
                stroke-width="2"
                stroke-miterlimit="10"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M259.483 60.6039H242.989V77.0981H259.483V60.6039Z"
                stroke="white"
                stroke-width="2"
                stroke-miterlimit="10"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M226.495 85.3452L222.371 48.2332"
                stroke="white"
                stroke-width="2"
                stroke-miterlimit="10"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M275.978 89.4688L280.101 48.2332"
                stroke="white"
                stroke-width="2"
                stroke-miterlimit="10"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M214.365 48.2332L231.152 23.4918H269.44L288.767 48.2332H214.365Z"
                stroke="white"
                stroke-width="2"
                stroke-miterlimit="10"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M230.724 22.7454L226.406 -18.2139"
                stroke="white"
                stroke-width="2"
                stroke-miterlimit="10"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M271.854 23.4918L275.977 -17.7438"
                stroke="white"
                stroke-width="2"
                stroke-miterlimit="10"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M185.259 72.9745H222.371"
                stroke="white"
                stroke-width="2"
                stroke-miterlimit="10"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M168.765 2.87403H185.259V-13.6202"
                stroke="white"
                stroke-width="2"
                stroke-miterlimit="10"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M280.101 147.199H296.595V163.693"
                stroke="white"
                stroke-width="2"
                stroke-miterlimit="10"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M205.877 72.9745V89.4688"
                stroke="white"
                stroke-width="2"
                stroke-miterlimit="10"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M384.591 165.425H368.727V150.695H359.662V165.425H343.799V141.63C343.799 141.004 344.305 140.497 344.932 140.497C345.559 140.497 346.065 141.004 346.065 141.63V163.159H357.396V148.429H370.994V163.159H382.325V142.763C382.325 142.138 382.831 141.63 383.458 141.63C384.085 141.63 384.591 142.138 384.591 142.763V165.425Z"
                fill="white"
              />
              <path
                d="M390.257 141.63C389.975 141.63 389.694 141.526 389.474 141.316L364.195 117.136L338.916 141.316C338.464 141.748 337.747 141.733 337.314 141.281C336.881 140.829 336.898 140.112 337.349 139.679L364.195 114L391.04 139.678C391.491 140.11 391.508 140.828 391.075 141.28C390.853 141.512 390.556 141.63 390.257 141.63Z"
                fill="white"
              />
              <path
                d="M381.192 128.033C380.565 128.033 380.059 127.525 380.059 126.899V120.101H373.26C372.633 120.101 372.127 119.593 372.127 118.968C372.127 118.342 372.633 117.835 373.26 117.835H382.325V126.899C382.325 127.525 381.819 128.033 381.192 128.033Z"
                fill="white"
              />
              <path
                d="M438.05 133.445L441.029 123.288L443.929 113.403C443.929 113.401 443.93 113.399 443.931 113.397L447.855 100.021L448.477 97.8995C448.477 97.8984 448.478 97.8977 448.478 97.8967L449.434 94.6383C449.532 94.303 449.762 94.0433 450.049 93.8936C450.152 93.7418 450.265 93.596 450.398 93.4632C452.365 91.4962 456.457 92.7928 460.988 95.7296C462.998 93.5076 464.098 90.6592 464.098 87.6415C464.098 84.4166 462.842 81.3847 460.562 79.1045C460.08 78.623 460.08 77.8424 460.562 77.3609C461.043 76.8797 461.824 76.8797 462.306 77.3609C467.721 82.7765 467.959 91.4335 463.028 97.1393C465.35 98.8411 467.72 100.894 469.924 103.099C469.925 103.1 469.927 103.102 469.928 103.103C474.313 100.44 479.368 99.0735 484.646 99.1972C485.327 99.2127 485.866 99.7774 485.85 100.458C485.834 101.139 485.275 101.68 484.589 101.662C479.983 101.553 475.561 102.695 471.685 104.928C473.318 106.69 474.793 108.475 476.05 110.209C481.235 108.25 487.321 109.35 491.488 113.517C491.97 113.999 491.97 114.779 491.488 115.261C491.007 115.742 490.226 115.742 489.745 115.261C487.464 112.98 484.432 111.724 481.208 111.724C479.923 111.724 478.67 111.927 477.481 112.311C477.905 112.978 478.293 113.633 478.638 114.27C481.332 119.244 480.627 121.559 479.56 122.625C479.425 122.76 479.279 122.876 479.125 122.981C478.975 123.264 478.716 123.49 478.384 123.587L475.127 124.544L475.126 124.545L468.372 126.527L468.371 126.528L454.09 130.718L453.127 131.001C453.126 131.001 453.125 131.001 453.124 131.001L439.579 134.976C439.465 135.009 439.348 135.026 439.232 135.026C438.91 135.026 438.595 134.899 438.361 134.665C438.042 134.345 437.923 133.878 438.05 133.445ZM443.358 124.11C445.908 124.054 447.966 121.963 447.966 119.399C447.966 117.797 447.166 116.345 445.888 115.487L443.514 123.579L443.358 124.11ZM449.003 104.869C450.732 108.122 453.76 112.02 457.381 115.644C460.998 119.261 464.895 122.289 468.153 124.021L473.045 122.585C469.103 120.9 464.264 117.22 460.033 112.99C455.802 108.758 452.123 103.918 450.438 99.976L449.957 101.617L449.003 104.869ZM476.47 115.445C476.098 114.758 475.671 114.048 475.199 113.323C474.286 113.849 473.435 114.496 472.671 115.261C472.43 115.501 472.114 115.622 471.799 115.622C471.484 115.622 471.168 115.501 470.927 115.261C470.445 114.779 470.445 113.999 470.927 113.517C471.804 112.64 472.766 111.9 473.787 111.294C472.572 109.651 471.153 107.96 469.582 106.287C468.493 107.072 467.456 107.947 466.486 108.917C466.245 109.157 465.93 109.278 465.614 109.278C465.299 109.278 464.983 109.157 464.742 108.917C464.261 108.435 464.261 107.654 464.742 107.173C465.717 106.198 466.753 105.308 467.838 104.503C460.912 97.6751 455.191 94.962 452.975 94.962C452.584 94.962 452.302 95.0462 452.142 95.2068C451.055 96.2935 453.471 102.94 461.777 111.246C470.083 119.553 476.729 121.97 477.817 120.882C478.176 120.523 478.356 118.925 476.47 115.445ZM458.633 126.431L456.951 126.498C456.547 126.509 456.158 126.329 455.915 126.003L454.906 124.653L454.448 126.273C454.338 126.663 454.043 126.974 453.659 127.105L452.06 127.648L453.198 128.41L458.293 126.914L458.633 126.431ZM450.116 129.314L448.614 128.309C448.224 128.048 448.016 127.588 448.078 127.123C448.139 126.658 448.459 126.268 448.903 126.117L452.252 124.978L453.213 121.578C453.34 121.126 453.713 120.786 454.175 120.701C454.637 120.614 455.106 120.799 455.387 121.175L457.503 124.008L461.033 123.87C461.504 123.854 461.941 124.101 462.165 124.513C462.386 124.921 462.359 125.417 462.097 125.799L464.908 124.974C461.942 123.09 458.684 120.434 455.637 117.387C452.589 114.336 449.933 111.077 448.051 108.114L446.603 113.048C448.933 114.271 450.431 116.694 450.431 119.399C450.431 123.357 447.211 126.577 443.254 126.577C443.05 126.577 442.846 126.565 442.643 126.548L441.051 131.974L450.116 129.314Z"
                fill="white"
              />
              <path
                d="M495.027 101.509C498.107 102.863 500.886 104.769 503.287 107.174C503.768 107.656 503.767 108.436 503.286 108.917C503.045 109.158 502.73 109.278 502.415 109.278C502.099 109.278 501.783 109.157 501.542 108.916C499.359 106.729 496.833 104.996 494.035 103.766C493.411 103.492 493.128 102.765 493.402 102.141C493.676 101.518 494.404 101.235 495.027 101.509Z"
                fill="white"
              />
              <path
                d="M485.53 88.6207L482.36 90.1851L481.851 93.6837C481.784 94.148 481.458 94.534 481.012 94.6788C480.887 94.7193 480.758 94.739 480.631 94.739C480.304 94.739 479.984 94.6087 479.748 94.3667L477.28 91.8351L473.796 92.4328C473.333 92.511 472.866 92.3219 472.59 91.9421C472.314 91.5624 472.278 91.059 472.496 90.6437L474.141 87.5146L472.496 84.3856C472.278 83.9702 472.314 83.4669 472.59 83.0871C472.866 82.7074 473.333 82.5183 473.796 82.5965L477.28 83.1939L479.748 80.6626C480.076 80.3265 480.566 80.2053 481.012 80.3505C481.458 80.4956 481.783 80.8813 481.851 81.3456L482.36 84.8442L485.53 86.4086C485.95 86.6164 486.217 87.0451 486.217 87.5143C486.217 87.9835 485.95 88.4129 485.53 88.6207ZM480.687 86.7693C480.323 86.5896 480.071 86.2426 480.013 85.8411L479.77 84.1731L478.594 85.38C478.311 85.6706 477.903 85.803 477.503 85.7347L475.842 85.4497L476.626 86.9412C476.815 87.3005 476.815 87.7295 476.626 88.0888L475.842 89.5803L477.503 89.2953C477.903 89.227 478.311 89.3594 478.594 89.65L479.77 90.8568L480.013 89.1893C480.071 88.7877 480.323 88.4407 480.687 88.2611L482.198 87.5153L480.687 86.7693Z"
                fill="white"
              />
              <path
                d="M487.339 118.72C489.317 118.72 490.927 120.329 490.927 122.308C490.927 124.286 489.317 125.895 487.339 125.895C485.361 125.895 483.751 124.286 483.751 122.308C483.751 120.329 485.361 118.72 487.339 118.72ZM487.339 123.429C487.958 123.429 488.461 122.926 488.461 122.308C488.461 121.689 487.958 121.186 487.339 121.186C486.72 121.186 486.217 121.689 486.217 122.308C486.217 122.926 486.72 123.429 487.339 123.429Z"
                fill="white"
              />
              <path
                d="M494.96 94.7393C492.407 94.7393 490.329 92.6621 490.329 90.1086C490.329 87.5551 492.407 85.4771 494.96 85.4771C497.514 85.4771 499.591 87.5547 499.591 90.1082C499.591 92.6617 497.514 94.7393 494.96 94.7393ZM494.96 87.9429C493.766 87.9429 492.795 88.9141 492.795 90.1082C492.795 91.302 493.766 92.2732 494.96 92.2732C496.154 92.2732 497.125 91.302 497.125 90.1082C497.125 88.9141 496.154 87.9429 494.96 87.9429Z"
                fill="white"
              />
              <path
                d="M73.511 111.255L70.1718 99.8723L66.9226 88.7945C66.9218 88.7921 66.9206 88.7901 66.9198 88.7873L62.5227 73.7983L61.8256 71.4207C61.8252 71.4195 61.8248 71.4187 61.8244 71.4176L60.753 67.7661C60.6429 67.3903 60.3859 67.0994 60.0642 66.9316C59.9481 66.7615 59.8218 66.5981 59.673 66.4492C57.4683 64.2449 52.8825 65.698 47.8048 68.9891C45.5528 66.499 44.32 63.307 44.32 59.9252C44.32 56.3113 45.7273 52.9137 48.2829 50.3584C48.8225 49.8188 48.8225 48.944 48.2829 48.4044C47.7433 47.8652 46.8685 47.8652 46.3289 48.4044C40.2604 54.4733 39.9935 64.1747 45.5196 70.5688C42.9174 72.4759 40.2616 74.7769 37.7912 77.2476C37.79 77.2488 37.7885 77.2504 37.7873 77.2516C32.8726 74.268 27.208 72.7364 21.293 72.875C20.5304 72.8923 19.926 73.5251 19.9438 74.2882C19.9616 75.0508 20.5884 75.6568 21.357 75.6374C26.5191 75.5151 31.4748 76.7944 35.8183 79.2976C33.9882 81.2721 32.335 83.2719 30.9265 85.2156C25.1162 83.02 18.2953 84.2525 13.6254 88.9223C13.0858 89.462 13.0858 90.3367 13.6254 90.8764C14.165 91.4156 15.0398 91.4156 15.5794 90.8764C18.135 88.3207 21.5327 86.9135 25.1466 86.9135C26.5866 86.9135 27.9908 87.1404 29.3227 87.5711C28.847 88.3188 28.4131 89.0522 28.0263 89.7663C25.0069 95.3398 25.7975 97.9341 26.9924 99.1294C27.1436 99.2802 27.3082 99.4101 27.4807 99.5277C27.6489 99.8455 27.9387 100.098 28.3109 100.207L31.9608 101.28L31.9616 101.28L39.5305 103.502L39.5321 103.502L55.5352 108.198L56.6145 108.515C56.6157 108.515 56.6165 108.515 56.6176 108.516L71.7966 112.97C71.9249 113.007 72.0555 113.026 72.1854 113.026C72.547 113.026 72.8999 112.884 73.1624 112.621C73.5193 112.263 73.6531 111.739 73.511 111.255ZM67.5621 100.793C64.7045 100.731 62.3988 98.3869 62.3988 95.5143C62.3988 93.7182 63.2944 92.091 64.727 91.1294L67.3872 100.198L67.5621 100.793ZM61.2358 79.2308C59.2984 82.876 55.9051 87.2447 51.8471 91.3055C47.7942 95.3587 43.4267 98.752 39.776 100.694L34.2937 99.0844C38.7114 97.1955 44.1341 93.0724 48.875 88.3314C53.6171 83.5893 57.7395 78.1658 59.628 73.7478L60.1676 75.5865L61.2358 79.2308ZM30.4556 91.0824C30.8724 90.3134 31.3509 89.5176 31.8794 88.7052C32.9026 89.2942 33.8564 90.019 34.7134 90.8764C34.9834 91.146 35.3371 91.281 35.6904 91.281C36.0437 91.281 36.3978 91.146 36.6674 90.8764C37.207 90.3367 37.207 89.462 36.6674 88.9223C35.6844 87.9394 34.606 87.1097 33.462 86.4311C34.8239 84.5896 36.4135 82.6944 38.1749 80.8205C39.3951 81.6996 40.5568 82.6798 41.644 83.7669C41.914 84.0365 42.2677 84.1715 42.621 84.1715C42.9743 84.1715 43.3284 84.0365 43.598 83.7669C44.1376 83.2273 44.1376 82.3525 43.598 81.8129C42.5053 80.7202 41.3452 79.7231 40.1293 78.8211C47.8901 71.1693 54.3012 68.1289 56.7854 68.1289C57.2228 68.1289 57.539 68.2232 57.7186 68.4032C58.9364 69.621 56.2296 77.0696 46.921 86.3778C37.6136 95.686 30.165 98.3948 28.9465 97.1754C28.5442 96.7735 28.3425 94.9829 30.4556 91.0824ZM50.4441 103.395L52.3295 103.469C52.7819 103.482 53.2181 103.28 53.4904 102.915L54.621 101.402L55.1338 103.217C55.2573 103.654 55.5881 104.003 56.0188 104.149L57.8102 104.758L56.5347 105.612L50.8259 103.935L50.4441 103.395ZM59.9884 106.625L61.6716 105.498C62.1086 105.206 62.3419 104.691 62.2732 104.17C62.2045 103.648 61.8457 103.211 61.3479 103.042L57.5954 101.766L56.5186 97.9554C56.3757 97.4493 55.9576 97.068 55.4405 96.9725C54.9226 96.8758 54.3968 97.083 54.0822 97.5042L51.7113 100.679L47.7551 100.524C47.2273 100.506 46.7378 100.783 46.4868 101.245C46.2389 101.702 46.2693 102.258 46.563 102.686L43.4121 101.761C46.7363 99.6497 50.3873 96.6737 53.8015 93.2591C57.2181 89.8397 60.1941 86.1879 62.3032 82.8673L63.9253 88.3969C61.3148 89.7675 59.6355 92.4826 59.6355 95.5143C59.6355 99.9493 63.2439 103.558 67.6789 103.558C67.9075 103.558 68.1357 103.544 68.3634 103.525L70.1473 109.606L59.9884 106.625Z"
                fill="white"
              />
              <path
                d="M9.66047 75.4658C6.20917 76.9832 3.09499 79.1188 0.403978 81.8138C-0.135251 82.3538 -0.134461 83.2286 0.405162 83.7678C0.675171 84.0374 1.02808 84.1716 1.38138 84.1716C1.73507 84.1716 2.08916 84.0366 2.35917 83.7662C4.80623 81.3156 7.63698 79.3738 10.7725 77.9954C11.4712 77.6883 11.7882 76.8731 11.4811 76.1744C11.1739 75.4761 10.3588 75.1587 9.66047 75.4658Z"
                fill="white"
              />
              <path
                d="M20.3034 61.0225L23.8557 62.7756L24.4257 66.6963C24.5011 67.2165 24.8659 67.6492 25.366 67.8114C25.5062 67.8568 25.6502 67.8789 25.7928 67.8789C26.1595 67.8789 26.5179 67.7329 26.7824 67.4617L29.5476 64.6246L33.4525 65.2945C33.9708 65.3821 34.495 65.1702 34.8037 64.7446C35.1128 64.3191 35.1535 63.755 34.9091 63.2896L33.0656 59.783L34.9091 56.2764C35.1539 55.811 35.1132 55.2469 34.8037 54.8214C34.4946 54.3959 33.9712 54.1839 33.4525 54.2715L29.5476 54.941L26.7824 52.1043C26.4153 51.7277 25.8662 51.5919 25.366 51.7546C24.8659 51.9172 24.5015 52.3495 24.4257 52.8697L23.8557 56.7904L20.3034 58.5435C19.8316 58.7764 19.5332 59.2568 19.5332 59.7826C19.5332 60.3084 19.832 60.7896 20.3034 61.0225ZM25.73 58.9477C26.1378 58.7464 26.4204 58.3576 26.4859 57.9075L26.7575 56.0384L28.0756 57.3908C28.393 57.7165 28.8497 57.8649 29.2985 57.7883L31.1598 57.469L30.2807 59.1404C30.0691 59.543 30.0691 60.0238 30.2807 60.4264L31.1598 62.0978L29.2985 61.7785C28.8501 61.7019 28.393 61.8503 28.0756 62.176L26.7575 63.5284L26.4859 61.6596C26.4204 61.2096 26.1382 60.8208 25.73 60.6195L24.0365 59.7838L25.73 58.9477Z"
                fill="white"
              />
              <path
                d="M18.2754 94.7528C16.0585 94.7528 14.2549 96.5564 14.2549 98.7733C14.2549 100.99 16.0585 102.794 18.2754 102.794C20.4923 102.794 22.2959 100.99 22.2959 98.7733C22.2959 96.5564 20.4923 94.7528 18.2754 94.7528ZM18.2754 100.031C17.5822 100.031 17.0181 99.4665 17.0181 98.7733C17.0181 98.0802 17.5822 97.5161 18.2754 97.5161C18.9686 97.5161 19.5327 98.0802 19.5327 98.7733C19.5327 99.4665 18.9686 100.031 18.2754 100.031Z"
                fill="white"
              />
              <path
                d="M9.73528 67.8794C12.5968 67.8794 14.9247 65.5516 14.9247 62.6901C14.9247 59.8285 12.5968 57.4999 9.73528 57.4999C6.87374 57.4999 4.5459 59.8281 4.5459 62.6897C4.5459 65.5512 6.87374 67.8794 9.73528 67.8794ZM9.73528 60.2631C11.0731 60.2631 12.1614 61.3515 12.1614 62.6897C12.1614 64.0275 11.0731 65.1158 9.73528 65.1158C8.39748 65.1158 7.30915 64.0275 7.30915 62.6897C7.30915 61.3515 8.39748 60.2631 9.73528 60.2631Z"
                fill="white"
              />
            </g>
          </svg>
        </div>
        <div className="flex items-center font-semibold justify-center bg-white lg:w-24 lg:h-24 w-16 h-16 p-3 lg:p-8 rounded-full text-[30px] lg:text-[40px] tracking-wider ml-1 m-1 lg:m-2 text-black">
          {villaData.a2z_score ? villaData.a2z_score : 0}
        </div>
      </div>
      <div>

      </div>
      <div className="w-[97%] mx-auto mb-10 relative lg:hidden block my-auto">
        <HeroCollage
          items={mediaItems}
          onOpenAt={(index) => {
            setLightboxIndex(index);
            setLightboxOpen(true);
          }}
          onShowAll={() => setOpen(true)}
          onViewVideo={() => {
            const videoIndex = mediaItems.findIndex((item) => item.isVideo);
            if (videoIndex < 0) return;
            setLightboxIndex(videoIndex);
            setLightboxOpen(true);
          }}
        />

        <div className="text-[30px] flex flex-row  items-center justify-between font-bold ml-2 mt-3">
          <div>{villaData.listing_name?villaData.listing_name:villaData.property_name}</div>
          <div>
            <RWebShare
              data={{
                url: `http://www.a2zvillaz.com/villa/${villaData.property_ptr_id}/${villaData?.listing_name?.replace(/\s+/g, "-")}`,
                title: "A2Z Villaz",
              }}
              onClick={() => console.log("shared successfully!")}
            >
              <button className=" cursor-pointer">

                <svg
                  width="30"
                  height="32"
                  viewBox="0 0 30 32"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M24.0548 21.0469C22.7 21.0464 21.399 21.5769 20.4307 22.5246L10.9923 17.2179C11.1863 16.4176 11.1863 15.5824 10.9923 14.7821L20.4277 9.47543C21.3092 10.3329 22.4671 10.8485 23.6941 10.9302C24.9211 11.0118 26.1371 10.6541 27.1244 9.92096C28.1117 9.18786 28.8058 8.12729 29.0825 6.92912C29.3592 5.73095 29.2004 4.47341 28.6346 3.38163C28.0687 2.28985 27.1327 1.43511 25.9942 0.970451C24.8557 0.505787 23.5889 0.461531 22.4207 0.845605C21.2525 1.22968 20.2592 2.01701 19.6185 3.06663C18.9778 4.11626 18.7317 5.35966 18.9241 6.57422L9.26599 12.007C8.50737 11.375 7.58435 10.9722 6.60505 10.8459C5.62576 10.7196 4.63074 10.8749 3.73657 11.2938C2.84241 11.7127 2.08612 12.3777 1.55631 13.2109C1.0265 14.0441 0.745117 15.0111 0.745117 15.9985C0.745117 16.9859 1.0265 17.9529 1.55631 18.7861C2.08612 19.6194 2.84241 20.2844 3.73657 20.7032C4.63074 21.1221 5.62576 21.2775 6.60505 21.1511C7.58435 21.0248 8.50737 20.622 9.26599 19.99L18.9241 25.4258C18.7571 26.4751 18.9159 27.5503 19.3789 28.5065C19.842 29.4628 20.5871 30.2541 21.5139 30.7737C22.4406 31.2934 23.5044 31.5164 24.5618 31.4127C25.6192 31.309 26.6194 30.8837 27.4275 30.1939C28.2357 29.5042 28.8129 28.5833 29.0815 27.5553C29.35 26.5273 29.2969 25.4417 28.9294 24.4449C28.5618 23.448 27.8974 22.5878 27.0258 21.9802C26.1542 21.3726 25.1173 21.0469 24.0548 21.0469Z"
                    fill="#020202"
                  />
                </svg>
              </button>
            </RWebShare>
          </div>
        </div>
        <div className="flex flex-row  mt-1 text-sm text-gray-600">
          <div>
            <svg width="25" height="22" viewBox="0 0 11 18" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M5.5 0C2.46186 0 0 2.51719 0 5.625C0 10.9969 5.5 18 5.5 18C5.5 18 11 10.9969 11 5.625C11 2.51719 8.53814 0 5.5 0ZM5.5 8.35312C4.06161 8.35312 2.89983 7.1625 2.89983 5.69531C2.89983 4.22813 4.06622 3.03281 5.5 3.03281C6.93839 3.03281 8.10017 4.22344 8.10017 5.69531C8.10017 7.1625 6.93839 8.35312 5.5 8.35312Z" fill="black" />
            </svg>


          </div>
          <div>
            {villaData.area
              ? villaData.area
              : villaData.building
                ? villaData.building
                : villaData.name}
          </div>
        </div>

        {open ? (
          <div className="fixed inset-0 z-[100000] flex flex-col bg-[#F7F7F7]">
            <header className="sticky top-0 z-20 flex items-center justify-between border-b border-black/5 bg-white/90 px-4 py-3 backdrop-blur-md">
              <div>
                <h2 className="text-lg font-bold text-[#222]">Photo gallery</h2>
                <p className="text-sm text-[#717171]">
                  {mediaItems.length} item{mediaItems.length === 1 ? "" : "s"}
                </p>
              </div>
              <button
                type="button"
                onClick={() => setOpen(false)}
                className="flex h-10 w-10 items-center justify-center rounded-full border border-black/10 bg-white text-[#222] shadow-sm"
                aria-label="Close gallery"
              >
                <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
                  <path
                    d="M1 1l12 12M13 1L1 13"
                    stroke="currentColor"
                    strokeWidth="1.8"
                    strokeLinecap="round"
                  />
                </svg>
              </button>
            </header>

            <div className="flex-1 overflow-y-auto custom-scrollbar px-3 py-4">
              <div className="gallery-library-grid">
                {mediaItems.map((option, index) => (
                  <button
                    key={`mobile-lib-${index}`}
                    type="button"
                    onClick={() => {
                      setLightboxIndex(index);
                      setLightboxOpen(true);
                    }}
                    className="gallery-library-tile group"
                  >
                    {option.isVideo ? (
                      <video
                        src={option.src}
                        className="transition-transform duration-500 group-hover:scale-[1.03]"
                        muted
                        loop
                        playsInline
                        autoPlay
                        preload="metadata"
                      />
                    ) : (
                      <img
                        src={option.src}
                        alt={`Property ${index + 1}`}
                        className="transition-transform duration-500 group-hover:scale-[1.03]"
                      />
                    )}
                    {option.isVideo ? (
                      <span className="absolute top-3 left-3 rounded-full bg-black/60 px-2.5 py-1 text-[11px] font-semibold uppercase tracking-wide text-white">
                        Video
                      </span>
                    ) : null}
                  </button>
                ))}
              </div>
            </div>
          </div>
        ) : null}

        <Lightbox
          open={lightboxOpen}
          close={() => setLightboxOpen(false)}
          index={lightboxIndex}
          slides={images}
          plugins={[Thumbnails, Zoom, Video]}
          on={{
            view: ({ index }) => setLightboxIndex(index),
          }}
          styles={{
            container: { backgroundColor: "rgba(0,0,0,0.92)" },
          }}
        />
      </div>
    </div>
  );
};

export default Title;
